<template>
    <v-container width="100%">
        <v-col>
            <v-row>
                <v-col>
                    <v-row>
                        <v-col>
                            <v-phone
                                label="phone"
                                v-model="phone"
                                no-country-selector
                                default-country-code="KR"
                                color="red"
                                valid-color="green"
                                @update="update_phone"
                            >
                            </v-phone>
                        </v-col>
                        <v-col>
                            <v-combobox
                                hide-selected
                                :items="services"
                                item-text="name"
                                item-value="id"
                                label="service"
                                v-model="selected_service"
                            ></v-combobox>
                        </v-col>
                    </v-row>
                    <v-row v-if="selected_service != null">
                        <DateSlider 
                            :step="selected_service.provide_date"
                            v-model="amount"
                        />
                    </v-row>
                </v-col>
                <v-col>
                    <v-btn @click="ask">
                        Ask
                    </v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-data-table
                    :items="requests? requests.requests: []"
                    :headers="headers"
                    :options.sync="options"
                    :server-items-length="requests?requests.total:0"
                    style="width: 100%"
                    disable-sort
                    dense
                >
                <template v-slot:top>
                    <v-row>
                        <v-col>
                            <v-text-field
                                label="phone"
                                v-model="options.phone"
                            ></v-text-field>

                        </v-col>
                    </v-row>
                </template>
                <template v-slot:item.req_time="{value}">
                    {{ t(value) }}
                </template>
                <template v-slot:item.complete_time="{value}">
                    <div v-if="value != null">
                        {{ t(value) }}
                    </div>
                </template>
                <template v-slot:item.end_time="{item}">
                    {{ e(item) }}
                </template>
                <template v-slot:item.from="{item}">
                    {{ item.req_from }}
                </template>
                </v-data-table>
            </v-row>
        </v-col>
    </v-container>
</template>

<script>
import gql from 'graphql-tag'
import moment from 'moment'
import Swal from 'sweetalert2'
import DateSlider from './DateSlider.vue'
export default {
    name: "ContractRequest",
    props: ['global'],
    created() {
        if ('ADMIN' == localStorage.getItem('_session_role_')) {
            this.headers.push({'text': 'from', 'value': 'from'})
        }
    },
    data() {
        return {
            headers: [
                {
                    text: "Ask time",
                    value: "req_time"
                },
                {
                    text: "Client name",
                    value: "contract_name"
                },
                {
                    text: "Ask service",
                    value: "service_name"
                },
                {
                    text: "Ask amount",
                    value: "amount"
                },
                {
                    text: "Complete",
                    value: "complete_time"
                },
                {
                    text: "Start time",
                    value: "start_time"
                },
                {
                    text: "End time",
                    value: "end_time"
                }
            ],
            options: {
                page: 1,
                itemsPerPage: 10,
            },
            selected_service: null,
            phone: null,
            amount: 0,
            phone_valid: false,
        };
    },
    methods: {
        update_phone(e) {
            this.phone_valid = e.isValid;
            this.phone = e.phoneNumber;
        },
        e(d) {
            if (d.start_time == null) return null;
            return moment(d.start_time).add(d.amount-1, 'days').format('YYYY-MM-DD')

        },
        t(date) {
            return moment(parseInt(date)).local().format("YYYY.MM.DD HH:mm");
        },
        ask() {
            console.log(this.selected_service);
            if (this.selected_service == null || this.selected_service.id == null || this.phone_valid == false) {
                Swal.fire({
                    icon: "error",
                    title: "Invalid data",
                });
                return;
            }
            this.$apollo.mutate({
                mutation: gql `
                    mutation q($serviceCode: Int!, $amount: Int!, $phone: String!) {
                        createRequest(service_id: $serviceCode, amount: $amount, phone: $phone) {
                            id
                        }
                    }`,
                variables: {
                    serviceCode: this.selected_service.id,
                    amount: parseInt(this.amount),
                    phone: this.phone
                }
            }).then(() => {
                Swal.fire({
                    icon: "success",
                    title: "메시지 전송 성공",
                    showConfirmButton: false,
                    toast: true,
                    timer: 1000
                });
                this.$apollo.queries.requests.refetch();
            }).catch((e) => {
                Swal.fire({
                    icon: "error",
                    text: e.message,
                });
            });
        }
    },
    watch: {
        'global.refresh': function() {
            if (this.global.refresh > 0)
                this.$apollo.queries.requests.startPolling(this.global.refresh)
            else
                this.$apollo.queries.requests.stopPolling(this.global.refresh)
        }
    },
    apollo: {
        requests: {
            query: gql `query req ($offset: Int, $limit: Int, $phone: String) {
                requests(offset: $offset, limit: $limit, phone: $phone) {
                    total
                    requests {
                        id
                        contract_name
                        req_time
                        service_name
                        amount
                        complete_time
                        start_time
                        req_from
                    }
            }}`,
            variables: function () {
                return {
                    limit: this.options.itemsPerPage,
                    offset: (this.options.page - 1) * this.options.itemsPerPage,
                    phone: this.options.phone
                };
            },
            fetchPolicy: "no-cache",
        },
        services: {
            query: gql `{
                services {
                    id
                    name
                    provide_date 
                }
            }`,
            fetchPolicy: "no-cache"
        }
    },
    components: { DateSlider }
}
</script>